<template>
    <div
        class="DashboardTopBar"
        :class="{ isTransparent: transparent, canUpgrade: canShowUpgrade && canUpgrade, disabled }"
    >
        <MemolifeLogo
            :class="{ '--global-clickable': $route.name !== 'DashboardHomeView' }"
            @click.native="$route.name !== 'DashboardHomeView' && navigateToHome()"
        />
        <a v-if="$route.name !== 'DashboardHomeView'" class="mobile-back-button" href="/home">{{ $t('back') }}</a>
        <div v-if="showElement" class="divider" />
        <div
            v-if="showElement"
            class="tab"
            :class="{ '--global-clickable': $route.name !== 'MemolifeTvView' }"
            @click="$route.name !== 'MemolifeTvView' && $router.push({ name: 'MemolifeTvView' })"
        >
            {{ $t('memolifeTvLabel') }}
        </div>
        <div class="spacer" />
        <!-- <div class="divider"></div> -->
        <UpgradeButton v-if="canShowUpgrade && canUpgrade" in-header />
        <DashboardTopBarDailyGoal class="dailyGoal" />
        <DashboardTopBarNotifications class="notifications" />

        <MyAvatar v-if="profile" ref="avatar" class="profile --global-clickable" @click.native="showProfileSidebar()" />

        <UpgradeBar v-if="canShowUpgrade && canUpgrade" />
    </div>
</template>

<translations>
  memolifeTvLabel: 'Video'
  memolifeTvLabel_no: 'Video'
  back: 'Back'
  back_no: 'Tilbake'
</translations>

<script>
import MemolifeLogo from '@/components/MemolifeLogo';
import MyAvatar from '@/components/MyAvatar';
import UpgradeButton from './UpgradeButton';
import DashboardAccountPopup from './DashboardAccountPopup';
import DashboardTopBarNotifications from './DashboardTopBarNotifications';
import DashboardTopBarDailyGoal from './DashboardTopBarDailyGoal';
import UpgradeBar from './UpgradeBar';

export default {
    components: {
        MemolifeLogo,
        DashboardTopBarNotifications,
        DashboardTopBarDailyGoal,
        UpgradeButton,
        UpgradeBar,
        MyAvatar
    },
    props: {
        transparent: {
            type: Boolean,
            default: false
        },
        canShowUpgrade: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        profile() {
            return this.$store.state.moduleAuth.profile;
        },
        canUpgrade() {
            return this.$can('upgrade', { modelName: 'Account' });
        },
        disabled() {
            return this.$store.getters['moduleApp/gettingStartedHasFocus'] && this.$route.name === 'DashboardHomeView';
        },
        showElement() {
            return this.$route.name === 'DashboardHomeView';
        }
    },
    methods: {
        navigateToHome() {
            this.$router.push({
                name: 'DashboardHomeView'
            });
        },
        showProfileSidebar() {
            this.$modal.open({
                component: DashboardAccountPopup,
                target: 'app-dropdown',
                hostOptions: {
                    pointAt: this.$refs.avatar.$el
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.DashboardTopBar {
    position: relative;
    height: $topBarHeight;
    display: flex;
    align-items: center;
    padding: 0 2em;

    &:not(.isTransparent) {
        background-color: $dashboard-topbarBgColor;
    }

    &.disabled::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(#12254d, 0.8);
    }

    .mobile-back-button {
        color: white;
        text-decoration: none;
        font-size: 14px;
        width: 64px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 6px;
        background: rgba(196, 196, 196, 0.15);
        cursor: pointer;
        @media (min-width: 530px) {
            display: none;
        }
    }
}

.tab {
    color: rgba(white, 0.9);
}

.divider {
    width: 1px;
    height: 1.5em;
    background-color: rgba(white, 0.2);
    margin: 0 1em;
}
.spacer {
    flex: 1;
}

.UpgradeButton {
    margin: 0 0.5em;
}

.profile {
    $size: 2.2em;
    width: $size;
    height: $size;
    margin: 0 1em;
    margin-left: 0.5em;
    margin-right: 0;
    flex-shrink: 0;
}

.hamburger {
    padding: 1em;
    padding-left: 0;
}
.hamburgerIcon {
    $size: 1em;
    width: $size;
    height: $size;
    display: block;
    fill: rgba(white, 0.8);
}

.upgradeBar {
    height: 2em;
    background-color: $standardButtonColor;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}
.upgradeBarLabel {
    font-size: 90%;
    text-transform: uppercase;
}

@include media('>=mobile') {
    .upgradeBar {
        display: none;
    }
}
@include media('<mobile') {
    .DashboardTopBar {
        padding: 0 1em;

        &.canUpgrade {
            padding-top: 2em;
            height: $topBarHeight + 2em;
        }
        &:not(.canUpgrade) {
            .upgradeBar {
                display: none;
            }
        }
    }
    .UpgradeButton {
        display: none;
    }
    .MemolifeLogo /deep/ .text {
        display: none;
    }
}
</style>
